const parse = (str: string) => {};

export const jwt = {parse};
